import Vue from 'vue'
import Router from 'vue-router'
const index = resolve => require(['../pages/index.vue'], resolve)
const about_km = resolve => require(['../pages/about_km.vue'], resolve)
const hongRen = resolve => require(['../pages/hongRen.vue'], resolve)
const show_km = resolve => require(['../pages/show_km.vue'], resolve)
const news_km = resolve => require(['../pages/news_km.vue'], resolve)
const join_km = resolve => require(['../pages/join_km.vue'], resolve)
const brand = resolve => require(['../components/cooperation/brand.vue'], resolve)
const report = resolve => require(['../components/cooperation/report.vue'], resolve)
const poe = resolve => require(['../components/cooperation/poe.vue'], resolve)
const hr = resolve => require(['../components/cooperation/hr.vue'], resolve)
const media = resolve => require(['../components/cooperation/media.vue'], resolve)
const post = resolve => require(['../components/join/post.vue'], resolve)
Vue.use(Router)

export default new Router({
  routes: [{
      'path': '/',
      'redirect': 'index'
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      'meta': {
        'title': '首页',
      },
    }, {
      path: '/about_km',
      name: 'about_km',
      component: about_km,
      'meta': {
        'title': '关于快美',
      },
    },
    {
      path: '/hongRen',
      name: 'hongRen',
      component: hongRen,
      'meta': {
        'title': '快美红人',
      },
    },
    {
      path: '/show_km',
      name: 'show_km',
      component: show_km,
      'meta': {
        'title': '直播电商',
      },
    },
    {
      path: '/news_km',
      name: 'news_km',
      component: news_km,
      'meta': {
        'title': '快新闻',
      },
    },
    {
      path: '/join_km',
      name: 'join_km',
      component: join_km,
      'meta': {
        'title': '加入快美',
      },
    },
    {
      path: '/brand',
      name: 'brand',
      component: brand,
      'meta': {
        'title': '品牌合作',
      },
    },
    {
      path: '/report',
      name: 'report',
      component: report,
      'meta': {
        'title': '直播合作',
      },
    },
    {
      path: '/poe',
      name: 'poe',
      component: poe,
      'meta': {
        'title': '达人合作',
      },
    },
    {
      path: '/hr',
      name: 'hr',
      component: hr,
      'meta': {
        'title': 'HR合作',
      },
    },
    {
      path: '/media',
      name: 'media',
      component: media,
      'meta': {
        'title': '媒体合作',
      },
    },
    {
      path: '/post',
      name: 'post',
      component: post,
      'meta': {
        'title': '热招岗位',
      },
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js